import { Type } from '@angular/core';
import { YealinkT41Component } from '../devices/yealink-devices/yealink-t41/yealink-t41.component';
import { YealinkT43Component } from '../devices/yealink-devices/yealink-t43/yealink-t43.component';
import { YealinkT44Component } from '../devices/yealink-devices/yealink-t44/yealink-t44.component';
import { YealinkT46Component } from '../devices/yealink-devices/yealink-t46/yealink-t46.component';
import { YealinkT53Component } from '../devices/yealink-devices/yealink-t53/yealink-t53.component';
import { YealinkT54Component } from '../devices/yealink-devices/yealink-t54/yealink-t54.component';

export const YEALINK_DEVICES_COMPONENTS: Record<string, Type<any>> = {
  T41: YealinkT41Component,
  T43: YealinkT43Component,
  T44: YealinkT44Component,
  T46: YealinkT46Component,
  T53: YealinkT53Component,
  T54: YealinkT54Component,
};
